<template>
  <div class="screeningitem_main">
    <slot name="icon">
      <img class="screeningitem_main_icon" :src="url" alt="" />
    </slot>
    <div class="screeningitem_main_content">
      <div class="screeningitem_main_content_number">
        {{ fromat ? fromat(value) : value }}{{ unit }}
      </div>
      <div class="screeningitem_main_content_title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    fromat: {
      type: Function,
      default: (i) => i,
    },
    value: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
      require: true,
    },
    unit: {
      type: String,
      default: "",
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.screeningitem_main {
  // min-height: 55px;
  display: flex;
  height: 30%;
  align-items: center;
  background: url("~@/assets/images/bigData/left_botx.png") no-repeat;
  background-size: 100% 100%;
  &_icon {
    width: 22px;
    margin: 0 15%;
  }
  &_content {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    &_number {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 1vw;
      color: #ffd70e;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    &_title {
      font-family: MicrosoftYaHei;
      font-size: 0.7vw;
      color: #aaddff;
      text-align: left;
      font-style: normal;
      text-transform: none;
      width: 98%;
    }
  }
}
</style>